
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activity/education",
      function () {
        return require("private-next-pages/activity/education.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/activity/education"])
      });
    }
  